export default __webpack_public_path__ + "static/media/3181.fa33ccd1.svg";